import {
  styled,
  Typography as MuiTypography,
  TypographyProps as MuiTypographyProps,
} from "@mui/material";

const StyledTypography = styled(MuiTypography)(() => ({
  fontFamily: "Montserrat, sans-serif",
}));

interface TypographyProps extends MuiTypographyProps {
  children: React.ReactNode;
}

export const BaseTypography: React.FC<TypographyProps> = ({ children, ...props }) => {
  return <StyledTypography {...props}>{children}</StyledTypography>;
};

export default BaseTypography;
